import DomainBadge from './DomainBadge'

export default DomainBadge
